type PageModule = Record<string, unknown>;

/**
 * Looks up an Inertia page component among the eagerly-globbed page modules.
 *
 * A plain `pages[key]` lookup returns `undefined` when the server asks for a
 * page this bundle does not have. Inertia then does `.then(m => m.default || m)`
 * and blows up with "Cannot read properties of undefined (reading 'default')",
 * which says nothing about *which* page was missing (ABASTOVIRTUAL-25N).
 *
 * Throwing here keeps the failure in the same place but names the page, so the
 * Sentry event is actionable.
 */
export function resolvePage(pages: Record<string, PageModule>, name: string): PageModule {
    const page = pages[`./pages/${name}.tsx`];

    if (!page) {
        throw new Error(
            `Inertia page not found: "${name}" (${Object.keys(pages).length} pages in this bundle)`
        );
    }

    return page;
}
